import { ArrowBack } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useAuthentications } from 'contexts/authentications'
import { useHistory, useParams } from 'react-router-dom'
import { onShowExpirationDate } from 'utils/date'

import { getIcon } from 'utils/get-icon'
import TableStatus from '../table-status'
import { useStyles } from './styles'

interface IRouteParams {
  id: string
  name: string
}

const AuthenticationsHeaderRevogation = () => {
  const classes = useStyles()
  const history = useHistory()

  const { id, name } = useParams<IRouteParams>()
  const { connectors, validate } = useAuthentications()

  const handleGoBack = () => history.push('/authentications')
  const isValid = validate !== null

  return (
    <Box className={classes.headerContainer}>
      <Box className={classes.headerBack}>
        <ArrowBack
          fontSize='small'
          color='primary'
          onClick={handleGoBack}
          sx={{ cursor: 'pointer' }}
        />
        <h1>Autenticações</h1>
      </Box>

      <Box className={classes.filter}>
        <Box className={classes.columnn}>
          <h3>Connector</h3>
          <Box className={classes.boxContent}>
            {getIcon(name)}
            <p>{name}</p>
            <TableStatus status={isValid ? 'authorized' : ''} />
          </Box>
        </Box>

        {validate && (
          <Box className={classes.columnn}>
            <h3>Data de expiração</h3>
            <span>{onShowExpirationDate(validate)}</span>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default AuthenticationsHeaderRevogation
